import * as rxjs from 'rxjs'

import * as effects from '../../effects'

/**
 * Recursively destroys all descendants of a feature when requested
 */
export const recursivelyDestroyFeatures = effects.create(feature =>
  feature.lifecycle.actions.destroy.observe().pipe(
    rxjs.filter(action => action.data.recursive),
    rxjs.mergeMap(action =>
      feature.children.map(child =>
        child.lifecycle.actions.destroy
          .from(action)
          .create({ recursive: true }),
      ),
    ),
  ),
)
